'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventVenue = function (_Component) {
  (0, _inherits3.default)(EventVenue, _Component);

  function EventVenue() {
    (0, _classCallCheck3.default)(this, EventVenue);
    return (0, _possibleConstructorReturn3.default)(this, (EventVenue.__proto__ || (0, _getPrototypeOf2.default)(EventVenue)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventVenue, [{
    key: 'render',
    value: function render() {
      var venue = this.props.venue;

      // Assemble address lines

      var lines = [];
      if (venue.address) lines.push(venue.address);
      if (venue.address2) lines.push(venue.address2);
      if (venue.city || venue.state || venue.zip) {
        var line = [];
        if (venue.city) line.push(venue.city);
        if (venue.state) line.push('(' + venue.state + ')');
        if (venue.zip) line.push(venue.zip);
        lines.push(line.join(' '));
      }

      // Add <br/> elements between lines
      var elements = [];
      for (var i = 0; i < lines.length; i += 1) {
        elements.push(lines[i]);
        if (i < lines.length - 1) {
          elements.push(_react2.default.createElement('br', { key: i }));
        }
      }

      var latlong = venue.latitude + ',' + venue.longitude;
      var directionsURL = 'http://www.google.com/maps/place/' + latlong + '/@' + latlong + ',15z';

      return _react2.default.createElement(
        'div',
        { className: 'EventVenue' },
        venue.name && _react2.default.createElement(
          'div',
          { className: 'name' },
          venue.name
        ),
        elements.length && _react2.default.createElement(
          'address',
          null,
          elements
        ),
        venue.latitude && venue.longitude && _react2.default.createElement(
          'div',
          { className: 'directions' },
          _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: directionsURL },
            (0, _i18n2.default)('directions')
          )
        )
      );
    }
  }]);
  return EventVenue;
}(_react.Component);

EventVenue.propTypes = {
  /**
   * A venue as returned by the Caligram API.
   */
  venue: _propTypes2.default.object.isRequired
};
EventVenue.defaultProps = {};
exports.default = EventVenue;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventVenue.js
// module id = 274
// module chunks = 0